import React, {useEffect, useState, useMemo} from 'react';
import {DeviceManager, FeatureDetector, SoundMeter, StreamHelpers} from 'eyeson';
import {Button, FormControl, InputLabel, LinearProgress, Menu, MenuItem, Select} from "@material-ui/core";

const getSelectedDeviceId = (stream, type) => {
  try {
    const tracks = stream[`get${type}Tracks`]();
    if (tracks.length > 0) {
      const settings = tracks[0].getSettings();
      return settings.deviceId;
    }
  } catch (error) {
    console.error(error);
  }
  return null;
};

const Settings = ({videoRef, handleSettingChanged}) => {
  const [cameras, setCameras] = useState()
  const [microphones, setMicrophones] = useState()
  const [speakers, setSpeakers] = useState()
  const [constraints, setConstraints] = useState()
  const [options, setOptions] = useState()

  const [stream, setStream] = useState()
  const [camera, setCamera] = useState("")
  const [microphone, setMicrophone] = useState("")
  const [speaker, setSpeaker] = useState("")

  const [microphoneMeter, setMicrophoneMeter] = useState("")

  const canChangeAudioOutput = useMemo(() => FeatureDetector.canChangeAudioOutput(), [])

  const deviceManager = useMemo(() => new DeviceManager, [])

  useEffect(() => {
    return () => {
      handleSettingChanged()
    }
  }, [])

  useEffect(() => {
    if (stream) {
      const soundMeter = new SoundMeter();

      soundMeter
        .connectToSource(stream)
        .onUpdate(event => {
          if (event.error) {
            console.error(event.error);
          }
          setMicrophoneMeter(event.value)
        })

      return () => {
        setMicrophoneMeter(0)
        soundMeter.stop();
      }
    }
  }, [stream, setMicrophoneMeter])

  useEffect(() => {
    if (deviceManager) {
      setCameras(deviceManager.cameras)
      setMicrophones(deviceManager.microphones)
      setSpeakers(deviceManager.speakers)
      setConstraints(deviceManager.constraints)
      setSpeaker(deviceManager.sinkId)

      deviceManager.onChange(event => {

        if (event.cameras) {
          setCameras(event.cameras);
        }

        if (event.microphones) {
          setMicrophones(event.microphones);
        }

        if (event.speakers) {
          setSpeakers(event.speakers);
        }

        if (event.constraints) {
          setConstraints(event.constraints);
        }

        if (event.options) {
          setOptions(event.options);
        }

        if (event.stream) {
          setStream(event.stream)
          const microphoneId = getSelectedDeviceId(event.stream, 'Audio');
          const cameraId = getSelectedDeviceId(event.stream, 'Video');
          setMicrophone(microphoneId);
          setCamera(cameraId);
          handleSettingChanged()
        }

        if (event.sinkId) {
          videoRef?.current?.setSinkId(event.sinkId)
          setSpeaker()
        }

        if (event.error) {
          alert(event.error)
          console.log(event.error)
        }
      });

      deviceManager.start()

      return () => {
        deviceManager.stop()
      }
    }
  }, [deviceManager, videoRef])

  const handleSelectVideoInput = (event) => {
    if (deviceManager) {
      deviceManager.setVideoInput(event.target.value)
      deviceManager.storeConstraints()
    }
  }

  const handleSelectAudioInput = (event) => {
    if (deviceManager) {
      deviceManager.setAudioInput(event.target.value)
      deviceManager.storeConstraints()
    }
  }

  async function handleSelectAudioOutput(event) {
    if (deviceManager) {
      deviceManager.setAudioOutput(event.target.value)
      deviceManager.storeConstraints()
      setSpeaker(event.target.value)
    }
  }

  return <div>
    <FormControl style={{width: "100%"}} disabled={!options?.video}>
      <InputLabel id="video-input-select-label">Camera</InputLabel>
      <Select
        labelId="video-input-select-label"
        id="video-input-select"
        value={camera || ""}
        onChange={handleSelectVideoInput}
      >
        {(cameras || []).map(camera => {
          return <MenuItem key={camera.deviceId} value={camera.deviceId}>{camera.label}</MenuItem>
        })}
      </Select>
    </FormControl>

    <FormControl style={{width: "100%", marginTop: "1.25rem"}} disabled={!options?.audio}>
      <InputLabel id="audio-input-select-label">Microphone</InputLabel>
      <Select
        labelId="audio-input-select-label"
        id="audio-input-select"
        value={microphone || ""}
        onChange={handleSelectAudioInput}
      >
        {(microphones || []).map(microphone => {
          return <MenuItem key={microphone.deviceId} value={microphone.deviceId}>{microphone.label}</MenuItem>
        })}
      </Select>
    </FormControl>
    <LinearProgress variant="determinate" value={microphoneMeter}/>

    <FormControl style={{width: "100%", marginTop: "1.25rem"}} disabled={!options?.audio}>
      <InputLabel id="audio-output-select-label">Speaker</InputLabel>
      <Select
        labelId="audio-output-select-label"
        id="audio-output-select"
        value={speaker || ""}
        onChange={handleSelectAudioOutput}
      >
        {(speakers || []).map(speaker => {
          return <MenuItem key={speaker.deviceId} value={speaker.deviceId}>{speaker.label}</MenuItem>
        })}
      </Select>
    </FormControl>
  </div>
}

export default Settings